var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAptoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 115 40",
    width: 115,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50.0076 26.9802.7818 6.1407h6.2937l-5.0037-27.78887h-6.2154l-15.6755 27.78887h6.2545l3.2055-6.1407zm-7.9745-4.6639 5.9418-11.4654h.0782l1.4463 11.4654z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.3152 30.9833c.7037 1.2437 2.4628 2.7206 5.4728 2.7206 6.1373 0 11.0627-5.8687 11.0627-13.02 0-5.1302-2.6972-8.0451-7.0754-8.0451-3.0491 0-5.3164 1.5157-6.411 2.7206h-.1172l.43-2.0988h-5.3555l-5.2382 26.7395h5.3555l1.7591-9.0168zm7.4664-14.2248c2.4237 0 3.5182 1.5935 3.5182 4.4696 0 4.3529-2.4236 8.3949-6.0982 8.3949-2.2673 0-3.5964-1.4769-3.5964-4.5084 0-4.1975 2.5019-8.3561 6.1764-8.3561z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.6975 13.2606-.7818 4.0809h2.8145l-1.8764 9.6387c-.9381 4.7027.6646 6.4905 4.6519 6.4905 1.0554 0 2.0327-.1166 3.3227-.3886l.7818-3.8866c-.7818.1166-1.1336.1555-1.72.1555-1.4073 0-2.1109-.3498-1.6809-2.4097l1.8764-9.5998h3.5963l.821-4.0809h-3.5964l1.1336-5.86869h-5.3554l-1.1337 5.86869z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.091 33.7428c7.271 0 12.197-5.6355 12.197-12.6702 0-5.2857-3.206-8.4727-8.913-8.4727-7.3099 0-12.2744 5.6355-12.2744 12.709 0 5.2469 3.2445 8.4339 8.9904 8.4339zm.431-4.1198c-2.6196 0-4.1051-1.5546-4.1051-4.4307 0-4.3529 2.4631-8.4727 6.4891-8.4727 2.619 0 4.066 1.5935 4.066 4.4307 0 4.3918-2.385 8.4727-6.45 8.4727z"
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.1999 19.9231 5.0054-7.1371s-5.6845-12.203662-5.8704-12.573589c-.186-.416168-.4649-.092482-.4649-.092482s-4.10268 6.646131-4.33512 6.923581c-.23244.27744-.04649.69361-.04649.69361zm9.195 1.6804h-8.1678s5.0608 11.1628 5.1538 11.3015.3254.0462.3254.0462 4.1997-6.7983 4.3392-7.0295.0465-.6011.0465-.6011z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.0517 20.1238 5.1421-7.3379s11.6678-.0894 11.9467-.0431c.3255.0462.1395.4161.1395.4161s-4.2655 6.41-4.4514 6.6412c-.186.2312-.4649.3237-.4649.3237zm-3.5721.0011-3.42175-7.3808h-4.09101c-.23245 0-.4184.3237-.4184.3237s-4.355293 6.5022-4.4947594 6.6872c-.0929776.0924-.04648876.2312 0 .2774.0929774.0925.1859564.0925.1859564.0925z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAptoLogo);
export default __webpack_public_path__ + "static/media/apto-logo.5a70a97a0d43633a4394346acff5a7fd.svg";
export { ForwardRef as ReactComponent };